// 全局共享数据示例
import { DEFAULT_NAME } from '@/constants';
import { useState } from 'react';

const useUser = () => {
  const [name, setName] = useState<string>(DEFAULT_NAME); // TODO
  const [token, setToken] = useState<string>('');
  const [userInfo, setUserInfo] = useState<any>({});

  return {
    name,
    setName,
    token,
    setToken,
    userInfo,
    setUserInfo,
  };
};

export default useUser;
